import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { z } from 'zod';
import { BlockCard } from '../lib/block-card.js';
import { cx } from '../lib/cx.js';
import { STATE_BG_CLASS, STATE_TONES } from '../lib/state-styles.js';
const LegendEntrySchema = z
    .object({
    label: z.string(),
    state: z.enum(STATE_TONES).optional(),
})
    .strict();
const SegmentSchema = z
    .object({
    label: z.string(),
    value: z.number().min(0),
    state: z.enum(STATE_TONES).optional(),
})
    .strict();
const StackedBarSchema = z
    .object({
    label: z.string(),
    value: z.string().optional(),
    segments: z.array(SegmentSchema),
})
    .strict();
export const StackedBarChartPropsSchema = z
    .object({
    title: z.string().optional(),
    unit: z.string().optional(),
    legend: z.array(LegendEntrySchema).optional(),
    bars: z.array(StackedBarSchema),
})
    .strict();
/** Renders a `stacked_bar_chart` block — one horizontal bar per category, segmented by series. */
export function StackedBarChartPrimitive({ title, unit, legend, bars }) {
    return (_jsxs(BlockCard, { title: title, children: [legend && legend.length > 0 ? (_jsx("div", { className: "mb-3 flex flex-wrap gap-3 text-xs", children: legend.map((entry, index) => (_jsxs("span", { className: "flex items-center gap-1.5 text-muted-foreground", children: [_jsx("span", { className: cx('size-2 rounded-full', STATE_BG_CLASS[entry.state ?? 'neutral']), "aria-hidden": true }), entry.label] }, index))) })) : null, _jsx("div", { className: "space-y-3", children: bars.map((bar, barIndex) => {
                    const total = bar.segments.reduce((sum, segment) => sum + segment.value, 0);
                    return (_jsxs("div", { children: [_jsxs("div", { className: "mb-1 flex items-baseline justify-between gap-2 text-xs", children: [_jsx("span", { className: "text-foreground", children: bar.label }), _jsxs("span", { className: "tabular-nums text-muted-foreground", children: [bar.value ?? total, unit ? ` ${unit}` : ''] })] }), _jsx("div", { className: "flex h-2 w-full overflow-hidden rounded-full bg-muted", children: total > 0
                                    ? bar.segments.map((segment, segmentIndex) => (_jsx("div", { title: `${segment.label}: ${segment.value}`, className: STATE_BG_CLASS[segment.state ?? 'neutral'], style: { width: `${(segment.value / total) * 100}%` } }, segmentIndex)))
                                    : null })] }, barIndex));
                }) })] }));
}
